import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgZone } from '@angular/core';
import { LoginService } from '../../login-service';
@Component({
  selector: 'app-passwordchange',
  templateUrl: './passwordchange.component.html',
  providers:[LoginService]
  // styleUrls: ['./passwordchange.component.scss']
})
export class PasswordchangeComponent implements OnInit {
  NewPassword:string;
  usertype:string;
  displaypasswordscreen:boolean;
  validateUserDetails:any;
  userID:string;
  usersList: any;
  displaypassscreen: string;
  subject:string;
  description:string;
  showmessage: boolean=false;
  constructor(private router:Router,private activateRoute:ActivatedRoute,private loginService:LoginService,private zone: NgZone) {
       this.userID = this.activateRoute.snapshot.params['userid'];
       this.usertype=localStorage.getItem('userType');
      //  this.displaypasswordscreen = this.activateRoute.snapshot.params['displaypasswordscreen'];
      }

  ngOnInit(): void {
this.GetUsers();
  }
  GetUsers(){
    this.loginService.GetUsers(this.usertype).subscribe(data=>
      {
        
        data = JSON.parse(data['_body']);
              this.usersList=JSON.parse(JSON.stringify(data));
              console.log(this.usersList);
              let filterUsers=this.usersList.filter(x=>x.id.toString()==this.userID.toString());
              if(filterUsers.length>0){
                this.validateUserDetails=filterUsers[0];
              }
      });
  }
  
  PasswordSet(){
    console.log(this.NewPassword)
    this.GetUsers();
    const json={
      emailparm:this.validateUserDetails.email,
      useridparm:this.validateUserDetails.id,
      passwordparm:this.NewPassword        
    }
    this.subject="Password Change alert"
    this.description="passwordchange"
    this.loginService.ResetPassword(json).subscribe(data=>
      {
  console.log(data);
  this.loginService.SendMail(this.validateUserDetails.email,this.validateUserDetails.id,this.description).subscribe(data=>{
    console.log(data);
      this.loginService.showSuccess("Mail Send Successfuly","");
      this.showmessage=true;
      
  })
    // this.router.navigate(['/login'])
    // console.log(this.validateUserDetails);
    // console.log(this.validateUserDetails.user_type);
    // localStorage.setItem('USERID',this.validateUserDetails.id);

    // if(this.validateUserDetails.user_type==='Initiator')
    // {

    //   localStorage.setItem('LOGGEDINAS',this.validateUserDetails.user_type);
    //   // this.router.navigate(['/initatorhead/initatorcollabo']);
    //   this.zone.run(() => {this.router.navigate(['/initatorhead/initatorcollabo','0','passwordchange']);
    // });
      
    // }
    // else if(this.validateUserDetails.user_type==='Collabarator')
    // {
    //   localStorage.setItem('LOGGEDINAS',this.validateUserDetails.user_type);
    //   this.router.navigate(['/header/collabo']);
      
    // }
  });
    
  }
}
